/** Decoration added only to the live preview document, never to saved lesson HTML. */
export function applyPreviewWatermark(doc: Document): void {
    if (!doc.body) return;
    const id = 'lesson-preview-watermark';
    if (doc.getElementById(id)) return;
    const watermark = doc.createElement('div');
    watermark.id = id;
    watermark.setAttribute('aria-hidden', 'true');
    const maskUrl = new URL('/assets/watermark-mask.png', window.location.href).href;
    watermark.style.cssText = `
        position: fixed;
        inset: 0;
        z-index: 2147483646;
        pointer-events: none;
        user-select: none;
        opacity: 0.04;
        background-color: var(--text-color, currentColor);
        mask-image: url("${maskUrl}");
        mask-mode: alpha;
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: min(70vw, 640px) auto;
        -webkit-mask-image: url("${maskUrl}");
        -webkit-mask-repeat: no-repeat;
        -webkit-mask-position: center;
        -webkit-mask-size: min(70vw, 640px) auto;
    `;
    doc.body.appendChild(watermark);
}
